const mapSalutation = (sal) => {
  let expr = (sal || '').toLowerCase();
  switch (expr) {
    case 'mr':
    case 'mr.':
    case 'herr':
      return 'Mr.';
    case 'ms':
    case 'ms.':
    case 'mrs.':
    case 'mrs':
    case 'frau':
      return 'Ms.';
    case 'team':
      return 'Team';
    default:
      return '';
  }
};

export const contact2sf = (c) => {
  return {
    Id: c.Id,
    FirstName: c.FirstName,
    LastName: c.LastName,
    Email: c.Email,
    Phone: c.Phone,
    Salutation: mapSalutation(c.Salutation),
    Position__c: c.Position__c.join(';'),
  };
};
